export const STAFF_EMAIL_DOMAIN = '@mindrealm.ai';

export function isStaffEmail(email: string | null | undefined): boolean {
  return email?.toLowerCase().endsWith(STAFF_EMAIL_DOMAIN) ?? false;
}
